(() => {
  const initUsageScenarios = (scope = document) => {
    scope.querySelectorAll('[data-usage-scenarios]').forEach((section) => {
      if (section.dataset.usageScenariosReady === 'true') return;
      section.dataset.usageScenariosReady = 'true';

      const items = section.querySelectorAll('[data-usage-reveal]');
      if (!items.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initUsageScenarios());
  } else {
    initUsageScenarios();
  }

  document.addEventListener('shopify:section:load', (event) => initUsageScenarios(event.target));
})();
